import React, { useState, useEffect, useRef } from "react";
import httpClient from "../utils/httpClients";
import { useNavigate, useLocation } from "react-router-dom";
import TopTost from "../utils/topTost";
import { toast } from "react-toastify";

function VerifyAccount() {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isLoading, setIsLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [resendLoading, setResendLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";
  const type = location.state?.type;

  // Use ref to track timer
  const timerRef = useRef(null);

  // Validate email and type on component mount
  useEffect(() => {
    if (!email) {
      TopTost.fire({
        icon: "error",
        title: "Email address is required for verification.",
      });
      navigate("/login");
      return;
    }

    if (type && !["s", "l", "reset"].includes(type)) {
      console.warn(`Invalid type parameter: ${type}`);
    }
  }, [email, navigate, type]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  // 🔴 BEFOREUNLOAD EVENT - जब window बंद हो या refresh हो
  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log("Clearing localStorage before unload");
      localStorage.clear();
    };

    // 🔴 PAGE VISIBILITY CHANGE - जब टैब change हो
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("Tab hidden, clearing localStorage");
        localStorage.clear();
      }
    };

    // window.addEventListener("beforeunload", handleBeforeUnload);
    // window.addEventListener("pagehide", handleBeforeUnload);
    // document.addEventListener("visibilitychange", handleVisibilityChange);

    // return () => {
    //   window.removeEventListener("beforeunload", handleBeforeUnload);
    //   window.removeEventListener("pagehide", handleBeforeUnload);
    //   document.removeEventListener("visibilitychange", handleVisibilityChange);
    // };
  }, []);

  // Timer effect
  useEffect(() => {
    if (resendTimer > 0) {
      timerRef.current = setInterval(() => {
        setResendTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [resendTimer]);

  // 🔴 NAVIGATE होने से पहले clear करने के लिए
  const handleNavigation = (to) => {
    // localStorage.clear();
    navigate(to);
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 3) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
    if (e.key === "ArrowRight" && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
    if (e.key === "ArrowLeft" && index > 0) {
      document.getElementById(`otp-${index - 1}`).focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").trim();

    if (/^\d+$/.test(pasteData)) {
      const digits = pasteData.slice(0, 4).split("");
      const newOtp = [...otp];

      digits.forEach((digit, index) => {
        if (index < 4) newOtp[index] = digit;
      });

      setOtp(newOtp);

      const lastFilledIndex = Math.min(digits.length - 1, 3);
      document.getElementById(`otp-${lastFilledIndex}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isLoading || resendLoading) return;

    if (!email) {
      TopTost.fire({
        icon: "error",
        title: "Email address is required for verification.",
      });
      return;
    }

    const otpValue = otp.join("");

    if (otpValue.length !== 4) {
      TopTost.fire({
        icon: "error",
        title: "Please enter the complete 4-digit OTP",
      });
      return;
    }

    setIsLoading(true);

    try {
      const res = await httpClient.post("common/auth/verify-otp", {
        otp: otpValue,
        email,
      });

      // if (res.data?.message) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }

      if (type === "s" || type === "l") {
        localStorage.clear();
        handleNavigation("/login");
      } else {
        if (res.data?.data?.token) {
          localStorage.setItem("volumeAuthToken", res.data.data.token);
        }
        handleNavigation("/reset-password", {
          state: { email, token: res.data?.data?.token },
          replace: true,
        });
      }
    } catch (err) {
      console.error("Verify OTP error:", err);
      // TopTost.fire({
      //   icon: "error",
      //   title:
      //     err.response?.data?.message ||
      //     "Verification failed. Please try again.",
      // });

      setOtp(["", "", "", ""]);
      document.getElementById("otp-0").focus();
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    console.log(
      "Resend clicked - timer:",
      resendTimer,
      "loading:",
      resendLoading,
    );

    if (resendLoading || resendTimer > 0) {
      console.log("Cannot resend - timer is:", resendTimer);
      return;
    }

    if (!email) {
      TopTost.fire({
        icon: "error",
        title: "Missing email address to resend OTP.",
      });
      return;
    }

    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }

    setOtp(["", "", "", ""]);

    try {
      setResendLoading(true);

      const res = await httpClient.post("/common/auth/forgot-password", {
        email,
        userType: "User",
      });
      if (res.data?.data?.token) {
        localStorage.setItem("volumeToken", res.data.data.token);
      }

      console.log("API success - setting timer to 60");
      setResendTimer(60);

      // if (res.data?.message) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }

      setTimeout(() => {
        document.getElementById("otp-0").focus();
      }, 100);
    } catch (err) {
      console.error("Resend OTP error:", err);
      setResendTimer(0);
      TopTost.fire({
        icon: "error",
        title:
          err.response?.data?.message ||
          "Failed to resend OTP. Please try again.",
      });
    } finally {
      setResendLoading(false);
    }
  };

  // Format timer display
  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
  };

  return (
    <div className="wrapper">
      <section className="login-content overflow-hidden">
        <div className="row no-gatheres align-items-center bg-white">
          <div className="col-md-12 col-lg-6 align-self-center">
            <a
              href="/"
              className="navbar-brand d-flex mt-5 align-items-center mb-3 justify-content-center text-primary"
              onClick={(e) => {
                e.preventDefault();
                localStorage.clear();
                navigate("/");
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Logo"
              />
            </a>
            <div className="row justify-content-center pt-5 px-4">
              <div className="col-md-9">
                <div className="card d-flex justify-content-center mb-0 auth-card iq-auth-form">
                  <div className="card-body">
                    <h2 className="mb-2 text-center">Verify Account</h2>
                    <p className="text-center">
                      Please enter the one-time OTP to verify your account.
                      <br />A code has been sent to <strong>{email}</strong>
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="otp-0" className="form-label">
                              OTP Code
                            </label>
                            <div
                              className="d-flex justify-content-center mb-3 gap-4"
                              onPaste={handlePaste}
                            >
                              {otp.map((digit, index) => (
                                <input
                                  key={index}
                                  id={`otp-${index}`}
                                  type="text"
                                  className="form-control text-center mx-1"
                                  style={{ width: "45px", height: "45px" }}
                                  value={digit}
                                  onChange={(e) =>
                                    handleOtpChange(index, e.target.value)
                                  }
                                  onKeyDown={(e) => handleKeyDown(index, e)}
                                  onPaste={handlePaste}
                                  maxLength={1}
                                  required
                                  disabled={isLoading || resendLoading}
                                  aria-label={`OTP digit ${index + 1}`}
                                  inputMode="numeric"
                                  pattern="\d*"
                                  autoFocus={index === 0}
                                />
                              ))}
                            </div>
                            <div className="text-center small text-muted">
                              Tip: You can paste the 4-digit code
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary px-5"
                          disabled={isLoading || resendLoading}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Verifying...
                            </>
                          ) : (
                            "Verify Account"
                          )}
                        </button>
                      </div>

                      <div className="text-center mt-3">
                        <p>
                          Didn't receive the code?{" "}
                          {resendTimer === 0 ? (
                            <button
                              type="button"
                              className="btn btn-link text-underline p-0"
                              onClick={handleResendOtp}
                              disabled={resendLoading || resendTimer > 0}
                            >
                              {resendLoading ? (
                                <>
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  Resending...
                                </>
                              ) : (
                                "Resend OTP"
                              )}
                            </button>
                          ) : (
                            <span className="text-muted">
                              Resend available in {formatTimer(resendTimer)}
                            </span>
                          )}
                        </p>
                      </div>

                      <div className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link text-decoration-none"
                          onClick={() => {
                            localStorage.clear();
                            navigate("/login");
                          }}
                          disabled={isLoading || resendLoading}
                        >
                          ← Back to Login
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-block d-none bg-primary p-0 overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/auth/01.jpg`}
              className="img-fluid gradient-main"
              alt="login background"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default VerifyAccount;
